// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__IU_AP","backendUrl":"App_backendUrl__rcx7b"};